module.exports = __webpack_public_path__ + "static/anzeigenkunden_hb8-e087b4e28d5cec7ddc4d773d28154c43.pdf";